/**
 * Заавал бөглөх ТЕКСТ талбарын дүрэм.
 *
 * antd-ийн `required` нь зөвхөн `''`, `null`, `undefined`-ыг л хоосонд тооцдог
 * тул зөвхөн зайгаар бөглөсөн ("   ") утга валидацаас нэвтэрч, бараа нэргүй
 * хадгалагдаад жагсаалтад хоосон линк болж харагддаг байсан. `whitespace` нь
 * зөвхөн зай агуулсан утгыг хоосонд тооцно.
 */
export const requiredText = (message, required = true) => ({
  required,
  whitespace: required,
  message,
});

/**
 * Тэмдэгтийн тооны дээд хязгаар.
 *
 * Сервер тал урт утгыг татгалздаг ч ойлгомжгүй алдаа (эсвэл HTTP 500) буцаадаг
 * тул хязгаарыг энд урьдчилж хэлнэ. Оролтод `maxLength`-ыг хамт тавь — тэгвэл
 * хэрэглэгч хязгаарыг бичиж байхдаа шууд мэдэрнэ.
 */
export const maxLengthRule = (label, max) => ({
  max,
  message: `${label} ${max} тэмдэгтээс урт байж болохгүй!`,
});

/**
 * Барааны нэрний уртын хязгаар. Сервер тал 80 тэмдэгтээс урт нэрийг татгалздаг
 * ч зөвхөн "Бүтээгдэхүүний нэр буруу байна." гэж хариулдаг — хэрэглэгч юуг
 * засахаа мэдэхгүй, бүх алхмыг туулсны эцэст л мэдэх тул энд урьдчилж шалгана.
 */
export const PRODUCT_TITLE_MAX_LENGTH = 80;

/** Барааны нэрний бүрэн дүрэм: заавал бөглөх + уртын хязгаар */
export const productTitleRules = () => [
  requiredText('Барааны нэр оруулна уу!'),
  maxLengthRule('Барааны нэр', PRODUCT_TITLE_MAX_LENGTH),
];

/**
 * Салбарын нэрний уртын хязгаар. 250-аас урт нэр сервер дээр HTTP 500 үүсгэдэг
 * тул энд зогсооно.
 */
export const BRANCH_NAME_MAX_LENGTH = 250;

/** Салбарын нэрний бүрэн дүрэм: заавал бөглөх + уртын хязгаар */
export const branchNameRules = () => [
  requiredText('Салбарын нэр дутуу байна.'),
  maxLengthRule('Салбарын нэр', BRANCH_NAME_MAX_LENGTH),
];

/**
 * Брэндийн нэрний уртын хязгаар. Урт нэр дээр сервер 500 буцааж, өгөгдлийн
 * сангийн дотоод алдааны текст хэрэглэгчид харагддаг байсан тул энд зогсооно.
 */
export const BRAND_NAME_MAX_LENGTH = 250;

/** Брэндийн нэрний бүрэн дүрэм: заавал бөглөх + уртын хязгаар */
export const brandNameRules = () => [
  requiredText('Брэнд дутуу байна!'),
  maxLengthRule('Брэндийн нэр', BRAND_NAME_MAX_LENGTH),
];

/**
 * Харилцагчийн нэрний уртын хязгаар. Сервер тал (ppcommon MerchantCustomers.name)
 * мөн 250 тэмдэгтээр хязгаарладаг — хоёр талын хязгаарыг адилхан байлгана.
 */
export const CUSTOMER_NAME_MAX_LENGTH = 250;

/**
 * Имэйл хаягийн уртын дээд хязгаар.
 *
 * Нэр (250), утас (8) дээр хязгаар тавьсан атлаа имэйлд огт байгаагүй тул 302
 * тэмдэгттэй хаяг ямар ч алдаагүй өнгөрдөг байв. RFC 5321-ийн зам (path)-ын
 * дээд урт 254 тэмдэгт — практикт хүчинтэй имэйл үүнээс урт байж чадахгүй.
 */
export const EMAIL_MAX_LENGTH = 254;

/**
 * Имэйл талбарын бүрэн дүрэм: заавал бөглөх + хэлбэр + уртын хязгаар.
 *
 * @param {string} [requiredMessage] хоосон үеийн мессеж
 * @param {boolean} [required] засах горимд имэйл сонголттой байж болно
 */
export const emailRules = (requiredMessage = 'Имэйл дутуу байна!', required = true) => [
  requiredText(requiredMessage, required),
  { type: 'email', message: 'Имэйл хаяг буруу байна.' },
  maxLengthRule('Имэйл', EMAIL_MAX_LENGTH),
];

/**
 * Барааны тайлбарын уртын хязгаар. Сервер тал (ppcommon/models/product/constants.js
 * PRODUCT_DESCRIPTION_MAX_LENGTH) мөн 500 тэмдэгтээс урт тайлбарыг татгалздаг —
 * хоёр талын хязгаарыг яг адилхан байлгана.
 */
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 500;

/** Барааны тайлбарын бүрэн дүрэм: заавал бөглөх + уртын хязгаар */
export const productDescriptionRules = (required = true) => [
  requiredText('Барааны тайлбар оруулна уу!', required),
  {
    max: PRODUCT_DESCRIPTION_MAX_LENGTH,
    message: `Барааны тайлбар ${PRODUCT_DESCRIPTION_MAX_LENGTH} тэмдэгтээс урт байж болохгүй!`,
  },
];

/**
 * Тоон талбарын алдааг олно.
 *
 * Хоосон эсэхийг `required` дүрэм шалгадаг тул энд алгасна.
 *
 * @returns {string|null} алдааны мессеж, зөв бол `null`
 */
const findNumberError = (label, value, { integer = false } = {}) => {
  if (value === undefined || value === null || value === '') return null;

  const number = Number(value);

  if (Number.isNaN(number)) return `${label} тоо байх ёстой!`;
  if (number < 0) return `${label} сөрөг байж болохгүй!`;
  if (integer && !Number.isInteger(number)) return `${label} бүхэл тоо байх ёстой!`;

  return null;
};

/** Алдаа олдвол ил мессежээр татгалзах antd дүрэм болгоно */
const toRule = (findError) => ({
  validator: (_, value) => {
    const error = findError(value);
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
});

/*
 * ТООН ТАЛБАРУУД
 *
 * Өмнө нь буруу утгыг ЧИМЭЭГҮЙ ЗАСДАГ байсан: InputNumber-ийн `parser` нь "-"-г
 * хасаж -5-ыг 5 болгодог, `min` нь фокус алдахад 0 (эсвэл `min`) рүү наадаг тул
 * хэрэглэгч бичсэнээсээ огт өөр утга хадгалагдсаныг мэдэхгүй үлддэг. Доорх
 * дүрмүүд утгыг хэвээр нь үлдээж, юу буруу байгааг ил хэлнэ.
 */

/** Тоо ширхэгийн талбар (нөөц, захиалгын тоо): сөрөг ба бутархайг татгалзана */
export const wholeNumberRule = (label) =>
  toRule((value) => findNumberError(label, value, { integer: true }));

/** Бутархай зөвшөөрөгдөх талбар (үнэ, жин, овор хэмжээ): зөвхөн сөрөгийг татгалзана */
export const nonNegativeRule = (label) => toRule((value) => findNumberError(label, value));

/** Захиалгын тоо ширхэгийн доод хязгаар — 0 ширхэг захиалга утгагүй */
export const MIN_ORDER_UNIT = 1;

/**
 * Захиалгын тоо ширхэгийн дээд хязгаар.
 *
 * Өмнө нь ямар ч дээд хязгаар байгаагүй тул 999,999,999 ширхэг захиалга үүсдэг
 * байсан. Бизнесийн албан ёсны хязгаар баримтжаагүй тул илэрхий утгагүй тоог
 * барих зорилгоор нэг саяг авав.
 */
export const MAX_ORDER_UNIT = 1000000;

/**
 * Захиалгын тоо ширхэгийн алдааг олно.
 *
 * Нэг л алдаа буцаана — сөрөг тоо нь "сөрөг байж болохгүй" ба "1-ээс багагүй"
 * хоёуланд таардаг тул тусад нь дүрэм болговол хоёр мессеж зэрэг харагдана.
 */
const findOrderUnitError = (label, value) => {
  const numberError = findNumberError(label, value, { integer: true });
  if (numberError) return numberError;

  // Хоосныг `required` дүрэм шалгана
  if (value === undefined || value === null || value === '') return null;

  const number = Number(value);

  if (number < MIN_ORDER_UNIT) return `${label} ${MIN_ORDER_UNIT}-ээс багагүй байх ёстой!`;
  if (number > MAX_ORDER_UNIT) {
    return `${label} ${MAX_ORDER_UNIT.toLocaleString('en-US')}-аас ихгүй байх ёстой!`;
  }

  return null;
};

/**
 * Захиалгын «Тоо ширхэг» талбарын бүрэн дүрэм.
 *
 * `InputNumber`-ийн `min`/`max`-ыг ЗОРИУДААР хэрэглэхгүй — тэдгээр нь фокус
 * алдахад утгыг чимээгүй хумьдаг тул хэрэглэгч бичсэнээсээ өөр тоо явсныг
 * мэдэхгүй үлддэг. Эдгээр дүрэм алдааг ил хэлж, алхам дамжихыг зогсооно.
 */
export const orderUnitRules = (label = 'Тоо ширхэг') => [
  { required: true, message: `${label} оруулна уу!` },
  toRule((value) => findOrderUnitError(label, value)),
];

/**
 * Нууц үгийн хамгийн богино урт.
 *
 * Нууц үг сэргээх хэсэгт `required`-ээс өөр ямар ч шалгалт байгаагүй тул нэг
 * тэмдэгт нууц үг ч тавигдаж байсан. Сервер талын бодлого баримтжаагүй тул
 * 8 тэмдэгтийн нийтлэг доод хязгаарыг барив.
 */
export const PASSWORD_MIN_LENGTH = 8;

/**
 * Нууц үгэнд ЗААВАЛ байх тэмдэгтийн ангиллууд.
 *
 * Латин үсгээр шалгана. Кирилл үсэг нь «том/жижиг үсэг» шалгуурыг хангахгүй —
 * бодлогыг хоёрдмол утгагүй байлгах зорилготой.
 */
const PASSWORD_CHARACTER_RULES = [
  { pattern: /[a-z]/, message: 'Нууц үгэнд жижиг үсэг (a-z) байх ёстой!' },
  { pattern: /[A-Z]/, message: 'Нууц үгэнд том үсэг (A-Z) байх ёстой!' },
  { pattern: /[0-9]/, message: 'Нууц үгэнд тоо (0-9) байх ёстой!' },
];

/** Талбарын доор урьдчилж харуулах зөвлөмж — хэрэглэгч алдаа гаргаж байж мэдэхгүйн тулд */
export const PASSWORD_HINT = `${PASSWORD_MIN_LENGTH}-аас доошгүй тэмдэгт, том болон жижиг үсэг, тоо агуулсан байна.`;

/**
 * Нууц үгийн алдааг олно.
 *
 * Өмнө нь ЗӨВХӨН уртыг нь шалгадаг байсан тул `12345678` гэх мэт зөвхөн тооноос
 * бүрдсэн нууц үг ямар ч алдаагүй өнгөрдөг байв.
 *
 * НЭГ Л алдаа буцаана — дөрвүүлэнг нь зэрэг харуулбал талбарын доор мессежийн
 * жагсаалт үүсч уншихад хэцүү болно. Урт нь дутуу бол эхлээд түүнийг хэлнэ,
 * учир нь нэмж бичихэд дутуу ангиллууд нь ихэвчлэн хамт нөхөгддөг.
 *
 * Хоосон эсэхийг `required` дүрэм шалгадаг тул энд алгасна.
 *
 * @returns {string|null} алдааны мессеж, зөв бол `null`
 */
export const findPasswordError = (value) => {
  const password = value == null ? '' : String(value);

  // Зөвхөн зайнаас бүрдсэн утгыг `requiredText` барина — энд давхар хэлэхгүй
  if (password.trim() === '') return null;

  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Нууц үг ${PASSWORD_MIN_LENGTH}-аас доошгүй тэмдэгттэй байх ёстой!`;
  }

  const missing = PASSWORD_CHARACTER_RULES.find(({ pattern }) => !pattern.test(password));

  return missing ? missing.message : null;
};

/**
 * Нууц үгийн дүрэм: заавал бөглөх (зөвхөн зай биш) + урт + тэмдэгтийн ангилал.
 *
 * Энэ шалгуур нь нууц үг ТАВИХ/СОЛИХ үед л ажиллана — нэвтрэх үед биш. Тиймээс
 * сул нууц үгтэй одоогийн хэрэглэгчид түгжигдэхгүй.
 *
 * @param {boolean} [required] Засах горимд нууц үг сонголттой байдаг —
 *   `false` бол хоосон үлдээж болох ч бөглөвөл шалгуур хэвээр хүчинтэй.
 */
export const passwordRules = (required = true) => [
  requiredText('Нууц үгээ оруулна уу!', required),
  toRule(findPasswordError),
];

/**
 * Хүний нэр/овгийн уртын хязгаар. Сервер талын хязгаар баримтжаагүй тул
 * илэрхий утгагүй урт (мянган тэмдэгт) оролтыг барих зорилгоор авав.
 */
export const PERSON_NAME_MAX_LENGTH = 100;

/** Хүний нэр/овгийн дүрэм: заавал бөглөх (зөвхөн зай биш) + уртын хязгаар */
export const personNameRules = (label) => [
  requiredText(`${label} дутуу байна!`),
  maxLengthRule(label, PERSON_NAME_MAX_LENGTH),
];

/** Утасны дугаарын урт */
export const PHONE_NUMBER_LENGTH = 8;

/**
 * Утасны дугаарын алдааг олно.
 *
 * Өмнө нь ЗӨВХӨН уртыг нь шалгадаг байсан тул "abcdefgh" гэх мэт 8 тэмдэгт
 * текст ямар ч алдаагүй өнгөрч, жагсаалтад утасны дугаарын оронд тэр текст
 * харагддаг байв. Сервер тал ч мөн зөвхөн төрөл, уртыг шалгадаг тул энд
 * зогсоохгүй бол өгөгдөл рүү шууд ордог.
 *
 * Хоосон эсэхийг `required` дүрэм шалгадаг тул энд алгасна.
 *
 * @returns {string|null} алдааны мессеж, зөв бол `null`
 */
export const findPhoneNumberError = (value) => {
  const phoneNumber = value == null ? '' : String(value);

  if (phoneNumber === '') return null;

  // Зай, зураас, үсэг, тусгай тэмдэгт — бүгд татгалзана
  if (!/^[0-9]+$/.test(phoneNumber)) return 'Утасны дугаар зөвхөн тооноос бүрдэнэ.';

  if (phoneNumber.length !== PHONE_NUMBER_LENGTH) {
    return `Утасны дугаар ${PHONE_NUMBER_LENGTH} оронтой байх ёстой.`;
  }

  return null;
};

/**
 * Утасны талбарын бүрэн дүрэм: заавал бөглөх + 8 оронтой тоо.
 *
 * Утгыг ЗОРИУДААР засварладаггүй — тоо биш тэмдэгтийг чимээгүй хасвал хэрэглэгч
 * бичсэнээсээ өөр дугаар хадгалагдсаныг мэдэхгүй үлдэнэ. Оронд нь юу буруу
 * байгааг ил хэлнэ.
 */
export const phoneNumberRules = (requiredMessage = 'Харилцагчийн утас дутуу байна!') => [
  { required: true, message: requiredMessage },
  toRule(findPhoneNumberError),
];

/**
 * Текст талбаруудын эхэн/төгсгөлийн илүү зайг цэвэрлэнэ. Бичиж байх үед биш,
 * зөвхөн хадгалахын өмнө дуудагдана — эс тэгвээс үг хооронд зай авах боломжгүй
 * болно.
 *
 * @param {object} values формын утгууд
 * @param {string[]} fields цэвэрлэх талбаруудын нэр
 * @returns {object} зөвхөн өөрчлөгдсөн талбарууд
 */
export const trimTextFields = (values = {}, fields = []) => {
  const trimmed = {};

  fields.forEach((field) => {
    const value = values[field];
    if (typeof value !== 'string') return;

    const next = value.trim();
    if (next !== value) trimmed[field] = next;
  });

  return trimmed;
};
